(function () {
    'use strict';

    angular
        .module('rms.common')
        .directive('rmsListEditable', directiveFunc);

    function directiveFunc() {
        return {
            restrict: 'E',
            scope: {
                model: '=',
                options: '=',
                getModel: '='
            },
            controllerAs: 'vm',
            controller: directiveCtrl,
            bindToController: true,
            templateUrl: 'common/app/components/list-editable/index'
        };
    }

    function directiveCtrl(SodLogger, $scope, $timeout, lodash) {
        const vm = this;
        this.$onInit = function() {
            $timeout(function() {
                try {
                    const modelPath = getModelPath();
                    if (lodash.get(vm, modelPath.join('.'), []).length > 0) {
                        vm.refs.list.select(vm.refs.list.element.children().first());
                    }
                } catch (e) {
                    SodLogger.error('ERROR IN GETTING FIRST OBJECT', e);
                }
            });
        }

        function getModelPath() {
            const modelPath = ['model'];
            if (lodash.has(vm.options, 'dataSchemaPath')) {
                modelPath.push(vm.options.dataSchemaPath);
            }
            return modelPath;
        }

        const datasource = new kendo.data.DataSource({
            data: (lodash.has(vm.options, 'dataSchemaPath')) ? vm.model[vm.options.dataSchemaPath] : vm.model
        });

        vm.options.list.dataSource = datasource;
        vm.options.list.change = function(e) {
            vm.setModel(vm.refs.list.dataItem(this.select()));
            $scope.$apply();
        };
        vm.options.list.selectable = true;

        vm.getModel = function() {
            const data = datasource.data();
            if (lodash.has(vm.options, 'dataSchemaPath')) {
                const model = angular.copy(vm.model);
                lodash.set(model, vm.options.dataSchemaPath, data);
                return model;
            } else {
                return data;
            }
        };

    }
})();